import Modal from './Modal';
import ModalShell from './ModalShell';

export {
  Modal,
  ModalShell,
};



// WEBPACK FOOTER //
// ../src/client/components/modal/index.js